Ext.define('SA.view.pvt.AutoRefreshingUnitDropdown', {
    alias: 'widget.pvt-auto-refreshing-unit-dropdown',
    extend: 'SA.view.ComboButton',

    textField: 'name',
    ui: 'underline',
    valueField: 'id',

    beforeRender() {
        this.callParent();

        this.refresh();

        this.mon(this.projectView, {
            'change:attribute': this.refresh,
            'change:geographicUnit': this.refresh,
            'change:location': this.refresh,
            'change:scale': this.refresh,

            scope: this
        });

        this.mon(this.projectView.getProject(), 'change:unitDiscoverable', this.refresh, this);
    },

    buildItems() {
        var allowedUnits = this.projectView.getAllowedGeographicUnits();

        return allowedUnits.length > 0 ? allowedUnits : [{id: null, name: '-'}];
    },

    refresh() {
        var model = this.projectView;

        model.syncGeographicUnits();

        this.refreshItems();
        this.setValue(model.getGeographicUnit());
    },

    selectHandler(unitId) {
        this.projectView.setGeographicUnit(unitId);
        this.projectView.save();
    },

    updateText(item) {
        this.setText(this.extractText(item).replace('Auto - ', ''));
    }
});